import type { SVGProps } from 'react';

const SvgArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 12" {...props}>
    <path
      fill={props.color}
      d="M6.63 1.855 3.523 5.269h16.414v1.463H3.524l3.105 3.414-1.04 1.008L.939 6 5.589.847z"
    />
  </svg>
);

export default SvgArrowLeft;
